module.exports = __webpack_public_path__ + "static/media/spiderman_01.b4139718.png";